module.exports = __webpack_public_path__ + "img/en.f8ab3a08.png";